import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { RequestsRoutes } from './requests.routes';
import { ListRequestsComponent } from './list-requests/list-requests.component';
import { FormRequestsComponent } from './_components/form-requests/form-requests.component';
import { AddRequestsComponent } from './add-requests/add-requests.component';
import { EditRequestsComponent } from './edit-requests/edit-requests.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        RequestsRoutes,
        SharedDocumalisModule,
        TranslateModule
    ],
    declarations: [
        ListRequestsComponent,
        AddRequestsComponent,
        EditRequestsComponent,
        FormRequestsComponent,
    ]
})
export class RequestsModule { }
